import { PatientGoal } from "./patient_goal_class";
import { InterviewSetShape, InterviewShape } from "../interfaces/classTypes";

export class PatientGoalInterview extends PatientGoal {
  public interviewSetIds: string | null;
  public interviewSets: InterviewSetShape[];

  constructor({
    achievementCondition,
    achievementProgress,
    achievementTarget,
    achievementTargetFormatted,
    achievementThreshold,
    active,
    continuous,
    createdAt,
    deactivatedAt,
    description,
    endDateFormatted,
    goalTemplate,
    id,
    goalTypeSpecifics,
    leaderboardEnabled,
    leaderboardIncluded,
    monitorProfileId,
    name,
    occurrenceAmount,
    occurrenceFrequency,
    startDateFormatted,
    type,
    updatedAt,
  }: any) {
    let extendedData = {
      achievementCondition: achievementCondition,
      achievementProgress: achievementProgress,
      achievementTarget: achievementTargetFormatted
        ? achievementTargetFormatted
        : achievementTarget,
      achievementThreshold: achievementThreshold,
      active: active,
      continuous: continuous,
      createdAt: createdAt,
      deactivatedAt: deactivatedAt,
      description: description,
      endDate: endDateFormatted,
      goalTemplateId: goalTemplate.id,
      id: id,
      leaderboardEnabled: leaderboardEnabled,
      leaderboardIncluded: leaderboardIncluded,
      monitorProfileId: monitorProfileId,
      name: name,
      occurrenceAmount: occurrenceAmount,
      occurrenceFrequency: occurrenceFrequency,
      startDate: startDateFormatted,
      type: type,
      updatedAt: updatedAt,
    };

    super(extendedData);
    this.interviewSetIds = goalTypeSpecifics;
    this.interviewSets = this.goalTemplate.selectedInterviewSets;
  }
}
